export const environment = {
  production: false,
  isTest: true,
  //apiUrl: 'http://localhost:3000/api', //for web app
  //apiUrl: 'http://10.0.2.2:3000/api', // For Android emulator
  //apiUrl: 'http://100.112.244.117:3000/api', // Emulating on physical Android device
  //apiUrl: 'http://192.168.0.40:3000/api', // for mobile app for physical device
  apiUrl: 'https://miflota-multitenant-backend.onrender.com/api', // deployed via render.com
  sendToDian: false,
};
